<script>
  export default {
    props: {

    },
    data() {
      return {
        searchData:{
          query: '',
          tag: '',
        },
        keywordList: []
      }
    },
    created() {
      this.getKeywordList()
    },
    methods: {
      async getKeywordList() {
        this.keywordList = await this.$store.dispatch("global/fetchKeyword", { hot: 1 })
      },
      onClickKeyword(keyword) {
        // this.$router.push({
        //   name: this.$route.name,
        //   params: {
        //     ...this.$route.params,
        //     tagTitle: keyword.title,
        //   },
        //   query: {
        //     ...this.$route.query,
        //     tagAlias: keyword.alias,
        //   },
        // })
        this.searchData.tag = keyword.alias
      },
      onSearch() {
        this.$router.push({
          name: 'search',
          query: {
            ...this.searchData
          }
        })
      },
      mobileSearchOpen(){
        this.searchData = {
          query: '',
          tag: '',
        };
        this.$emit('mobileSearchOpen', false)
      }
    }
  }
</script>
<template>
  <div :class="$style.mobileSearch">
    <div class="text-2xl font-medium">全站搜尋</div>
    <el-divider class="isStyleHeader my-4"></el-divider>
    <el-input v-model="searchData.query" class="isStyleBase isStyleSearch" placeholder="請輸入關鍵字"></el-input>
    <BaseKeyword
      title="熱門關鍵字"
      class="mt-5"
      :list="keywordList"
      @click="onClickKeyword"
    />
    <BaseButton 
      class="isStylePrimary isFull isRadius mt-5"
      @click="onSearch"
    >
      搜尋
    </BaseButton>
    <BaseButton class="isStyleDark isOutline isFull isRadius mt-3" @click="mobileSearchOpen">
      取消
    </BaseButton>
  </div>
</template>
<style lang="scss" module>
  .mobileSearch {
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    // height: calc(100vh - 48px);
    height: calc((var(--vh, 1vh) * 100) - 70px);
    padding: 2rem $container-gap;
    overflow: auto;
    background: #FFF;
    @include max-md {
      top: 48px;
      height: calc((var(--vh, 1vh) * 100) - 48px);
    }
  }
</style>
